import React from 'react'
import CloudManageHero from './cloudManageHero/CloudManageHero'
import SecureCloudmanage from './secureCloudmanage/SecureCloudmanage'
import CloudmanageIndustry from './CloudmanageIndustry/CloudmanageIndustry'
import CloudmanageTestimonial from './CloudmanageTestimonial/CloudmanageTestimonial'
import CloudmanageService from './cloudmanageService/CloudmanageService'
import CloudmanageModern from './cloudmanageModern/CloudmanageModern'
import CloudmanageBuild from './cloudmanageBuild/CloudmanageBuild'
import CloudmanageDiverse from './cloudmanageDiverse/CloudmanageDiverse'
import CloudManageSuite from './cloudManageSuite/CloudManageSuite'

export default function CloudManage() {
  return (
    <div>
        <CloudManageHero/>
        <SecureCloudmanage/>
        <CloudmanageIndustry/>
        <CloudmanageModern/>
        <CloudManageSuite/>
        <CloudmanageBuild/>
        <CloudmanageDiverse/>
        <CloudmanageTestimonial/>
        <CloudmanageService/>
    </div>
  )
}
